/* eslint-disable */
import { ajax, download, staticDownload, excelAjax, ajax2 } from './ajax'
import Exif from 'exif-js'

const util = {
  ajax,
  download,
  staticDownload,
  excelAjax,
  ajax2
}

let lastValue = {}

util.title = function (title) {
  title = title || '蓝卫科技-机动车排放治理信息管理系统'
  window.document.title = title
}

// eslint-disable-next-line no-undef
util.moment = moment

util.inOf = function (arr, targetArr) {
  let res = true
  arr.forEach(item => {
    if (targetArr.indexOf(item) < 0) {
      res = false
    }
  })
  return res
}

util.oneOf = function (ele, targetArr) {
  return targetArr.indexOf(ele) >= 0
}

util.getRouterObjByName = function (routers, name) {
  if (!name || !routers || !routers.length) {
    return null
  }
  // debugger;
  let routerObj = null
  for (let item of routers) {
    if (item.name === name) {
      return item
    }
    routerObj = util.getRouterObjByName(item.children, name)
    if (routerObj) {
      return routerObj
    }
  }
  return null
}

util.handleTitle = function (vm, item) {
  if (typeof item.title === 'object') {
    return vm.$t(item.title.i18n)
  } else {
    return item.title
  }
}

function isOther (router) {
  return router.name.endsWith('OtherRouter')
}

util.setCurrentPath = function (vm, name) {
  let title = ''
  let isOtherRouter = false
  vm.$store.state.app.routers.forEach(item => {
    if (item.children.length === 1) {
      if (item.children[0].name === name) {
        title = util.handleTitle(vm, item)
        if (isOther(item)) {
          isOtherRouter = true
        }
      }
    } else {
      item.children.forEach(child => {
        if (child.name === name) {
          title = util.handleTitle(vm, child)
          if (isOther(item)) {
            isOtherRouter = true
          }
        }
      })
    }
  })
  let currentPathArr = []
  if (name === 'HomeIndex') {
    currentPathArr = [
      {
        title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'HomeIndex')),
        path: '',
        name: 'HomeIndex'
      }
    ]
  } else if ((name.indexOf('_index') >= 0 || isOtherRouter) && name !== 'HomeIndex') {
    currentPathArr = [
      {
        title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'HomeIndex')),
        path: '/home',
        name: 'HomeIndex'
      },
      {
        title: title,
        path: '',
        name: name
      }
    ]
  } else {
    let currentPathObj = vm.$store.state.app.routers.filter(item => {
      if (item.children.length === 1) {
        return item.children[0].name === name
      } else {
        let i = 0
        let childArr = item.children
        let len = childArr.length
        while (i < len) {
          if (childArr[i].name === name) {
            return true
          }
          i++
        }
        return false
      }
    })[0]
    if (currentPathObj.children.length <= 0 && currentPathObj.name === 'home') {
      currentPathArr = [
        {
          title: '首页',
          path: '',
          name: 'HomeIndex'
        }
      ]
    } else if (currentPathObj.children.length <= 0 && currentPathObj.name !== 'home') {
      currentPathArr = [
        {
          title: '首页',
          path: '/home',
          name: 'HomeIndex'
        },
        {
          title: currentPathObj.title,
          path: '',
          name: name
        }
      ]
    } else {
      let childObj = currentPathObj.children.filter((child) => {
        return child.name === name
      })[0]
      currentPathArr = [
        {
          title: '首页',
          path: '/home',
          name: 'HomeIndex'
        },
        {
          title: currentPathObj.title,
          path: '',
          name: currentPathObj.name
        },
        {
          title: childObj.title,
          path: currentPathObj.path + '/' + childObj.path,
          name: name
        }
      ]
    }
  }
  vm.$store.commit('setCurrentPath', currentPathArr)

  return currentPathArr
}

util.openNewPage = function (vm, name, argu, query) {
  let pageOpenedList = vm.$store.state.app.pageOpenedList
  let openedPageLen = pageOpenedList.length
  let i = 0
  let tagHasOpened = false
  while (i < openedPageLen) {
    if (name === pageOpenedList[i].name) { // 页面已经打开
      vm.$store.commit('pageOpenedList', {
        index: i,
        argu: argu,
        query: query
      })
      tagHasOpened = true
      break
    }
    i++
  }
  if (!tagHasOpened) {
    let tag = vm.$store.state.app.tagsList.filter((item) => {
      if (item.children) {
        return name === item.children[0].name
      } else {
        return name === item.name
      }
    })
    tag = tag[0]
    if (tag) {
      tag = tag.children ? tag.children[0] : tag
      if (argu) {
        tag.argu = argu
      }
      if (query) {
        tag.query = query
      }
      vm.$store.commit('increateTag', tag)
    }
  }
  vm.$store.commit('setCurrentPageName', name)
}

/**
 * 单点登录相关
 * 由于使用了keep-alive, 在二次登录不同账号后，前账号点击已打开tags时会使用缓存而不刷新数据，
 * 刷新当前页面重置所有数据，相当于重新登录
 * TODO: 过滤已打开的Tags
 * */
util.checkLoginChanged = function (store, to, router) {
  let user = JSON.parse(localStorage.getItem('user')) || {}
  let account = user.account
  let vuexAccount = store.state.user.user.account
  if (account !== vuexAccount && account && vuexAccount && router.currentRoute.name !== 'login') {
    router.go(0)
  }
}

util.toDefaultPage = function (routers, name, route, next) {
  let len = routers.length
  let i = 0
  let notHandle = true
  while (i < len) {
    if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
      route.replace({
        name: routers[i].children[0].name
      })
      notHandle = false
      next()
      break
    }
    i++
  }
  if (notHandle) {
    next()
  }
}

util.fullscreenEvent = function (vm) {
  vm.$store.commit('initCachepage')
  // 权限菜单过滤相关
  vm.$store.commit('updateMenulist')
  // 全屏相关
}

util.loginTimeOut = function () {
  let user = localStorage.getItem('user')
  let loginTime = localStorage.getItem('loginTime')
  let time = new Date().getTime()
  // 帐号不存在
  if (!user) {
    return true
  }
  // 登录信息是否已经超时
  if (time - loginTime > 30 * 60 * 1000) {
    return true
  }

  localStorage.setItem('loginTime', time)
  return false
}

util.getUrlKey = function (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=([^&;]+?)(&|#|;|$)').exec(location.href) || [''])[1].replace(/\+/g, '%20')) || null
}

util.has = function (authorities, router) {
  return !router.has || util.oneOf(router.has, authorities)
}

util.checkFormData = function (event, formData) {
  let flag = false
  formData.forEach(() => {
    flag = true
  })
  if (!flag) {
    event.$Message.error(`请输入筛选条件`)
  }
  return flag
}

util.requestId = function (vm, type) {
  // 应该使用是否返回来判断，而不是使用时间判断
  let loadingInType = vm.$store.state.load.loading && vm.$store.state.load.loading[type]
  if (loadingInType && lastValue && lastValue[type]) {
    return lastValue[type]
  }
  let nowDate = new Date().valueOf()
  lastValue[type] = nowDate + Math.random().toString().slice(-6)
  return lastValue[type]
}

util.getUser = function () {
  const storage = window.localStorage
  let userInfoTemp = storage.getItem('user')
  let userInfo = JSON.parse(userInfoTemp)
  return userInfo || {}
}

// 强制执行resize事件，
// 触发页面table高度的重新计算
util.forceResize = function () {
  if (Event.prototype.initEvent) {
    const evt = window.document.createEvent('UIEvents')
    evt.initUIEvent('resize', true, false, window, 0)
    window.dispatchEvent(evt)
  } else {
    window.dispatchEvent(new Event('resize'))
  }
}

// 用于获取url参数
util.getQueryVariable = function (url) {
  let arrObj = url.split('?')
  let params = Object.create(null)
  if (arrObj.length > 1) {
    arrObj = arrObj[1].split('&')
    arrObj.forEach(item => {
      item = item.split('=')
      params[item[0]] = item[1]
    })
  }
  console.log(params);
  return params
}

// 图片压缩
export function photoCompress (file, w, objDiv) {
  var orientation
  Exif.getData(file, function () {
    orientation = Exif.getTag(this, 'Orientation')
    var reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      getImgData(this.result, orientation, function (data) {
        // var re = this.result
        canvasDataURL(data, w, objDiv)
      })
    }
  })
}

function getImgData (img, dir, next) {
  var image = new Image()
  image.onload = function () {
    var degree = 0
    var drawWidth
    var drawHeight
    var width
    var height
    drawWidth = this.naturalWidth
    drawHeight = this.naturalHeight
    // 以下改变一下图片大小
    var maxSide = Math.max(drawWidth, drawHeight)
    if (maxSide > 1024) {
      var minSide = Math.min(drawWidth, drawHeight)
      minSide = (minSide / maxSide) * 1024
      maxSide = 1024
      if (drawWidth > drawHeight) {
        drawWidth = maxSide
        drawHeight = minSide
      } else {
        drawWidth = minSide
        drawHeight = maxSide
      }
    }
    var canvas = document.createElement('canvas')
    canvas.width = width = drawWidth
    canvas.height = height = drawHeight
    var context = canvas.getContext('2d')
    // 判断图片方向，重置canvas大小，确定旋转角度，iphone默认的是home键在右方的横屏拍摄方式
    switch (dir) {
    // iphone横屏拍摄，此时home键在左侧
    case 3:
      degree = 180
      drawWidth = -width
      drawHeight = -height
      break
    // iphone竖屏拍摄，此时home键在下方(正常拿手机的方向)
    case 6:
      canvas.width = height
      canvas.height = width
      degree = 90
      drawWidth = width
      drawHeight = -height
      break
    // iphone竖屏拍摄，此时home键在上方
    case 8:
      canvas.width = height
      canvas.height = width
      degree = 270
      drawWidth = -width
      drawHeight = height
      break
    }
    // 使用canvas旋转校正
    context.rotate((degree * Math.PI) / 180)
    context.drawImage(this, 0, 0, drawWidth, drawHeight)
    // 返回校正图片
    next(canvas.toDataURL('image/jpeg', 0.8))
  }
  image.src = img
}

function canvasDataURL (path, obj, callback) {
  var img = new Image()
  img.src = path
  img.onload = function () {
    var that = this
    // 默认按比例压缩
    var w = that.width
    var h = that.height
    var scale = w / h
    w = obj.width || w
    h = obj.height || w / scale
    var quality = 0.7 // 默认图片质量为0.7
    // 生成canvas
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')
    // 创建属性节点
    var anw = document.createAttribute('width')
    anw.nodeValue = w
    var anh = document.createAttribute('height')
    anh.nodeValue = h
    canvas.setAttributeNode(anw)
    canvas.setAttributeNode(anh)
    ctx.drawImage(that, 0, 0, w, h)
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality
    }
    // quality值越小，所绘制出的图像越模糊
    var base64 = canvas.toDataURL('image/jpeg', quality)
    // 回调函数返回base64的值
    callback(base64)
  }
}

//  转file对象
export function dataURLtoFile (dataurl, filename) {
  // 将base64转换为文件
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, {type: mime})
}

export default util
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         


// WEBPACK FOOTER //
// ./src/libs/util.js